import React, { Component, createRef, RefObject, ChangeEvent, KeyboardEvent } from 'react';
import { X } from 'react-feather';
import cn from 'classnames';
import type { InputEvent } from './set';

interface IProps {
  autoFocus?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  defaultValue?: string;
  onBlur: (e: InputEvent) => void;
  onKeyDown: (e: KeyboardEvent<HTMLInputElement>, i?: number) => void;
  onClear?: () => void;
  required?: boolean;
  type: string;
  key?: number;
  className?: string;
}

interface IState {
  valid: boolean;
}

class AutoresizableInput extends Component<IProps, IState> {
  state = { valid: true };

  input: RefObject<HTMLInputElement> = createRef();

  componentDidMount() {
    const { autoFocus } = this.props;

    this.autoResize();
    if (autoFocus) {
      this.input.current?.focus();
    }
  }

  onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { onChange } = this.props;

    this.autoResize();
    if (onChange) {
      onChange(e);
    }
  };

  get value() {
    return this.input.current?.value;
  }

  autoResize() {
    if (this.input && this.input.current) {
      const inputRef = this.input.current;
      const scrollWidthOffset = 6;

      inputRef.style.width = '0';
      let newWidth = inputRef.scrollWidth + scrollWidthOffset;

      if (inputRef.scrollWidth >= inputRef.clientWidth) newWidth += scrollWidthOffset;
      inputRef.style.width = `${newWidth}px`;
    }
  }

  render() {
    const { value, defaultValue, onBlur, onKeyDown, onClear, required } = this.props;
    const { valid } = this.state;
    const isRequired = required ?? false;

    return (
      <React.Fragment>
        <input
          required={isRequired}
          type="text"
          value={value}
          defaultValue={defaultValue}
          className={cn('cc-input', { invalid: !valid })}
          ref={this.input}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          onChange={this.onChange}
        />
        {onClear && (
          <button tabIndex={-1} className="button-icon" type="button" onClick={onClear}>
            <X size={12} />
          </button>
        )}
      </React.Fragment>
    );
  }
}

export default AutoresizableInput;
